import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import Cart from './modules/cart';
import Localization from './modules/localization';
import ProductForm from './modules/product-form';
import Slider from './modules/sliders';
import './modules/aos';
import './modules/text-animation';
import './modules/modal-onload';
import './modules/global-modal';

document.addEventListener('DOMContentLoaded', (): void => {
  const slider = new Slider();
  slider.setup();

  // Initialize cart and make it globally available
  const cart = new Cart();
  window.themeCart = cart;

  new ProductForm();
  new Localization();
});
